// extracted by mini-css-extract-plugin
export var container = "index-module--container--nkg-l";
export var fadein = "index-module--fadein--v6DLr";